import React, { useEffect, useRef } from 'react';
import styles from './annotationsSidebar.scss';
import { t } from '../../services/i18nService';
import AnnotationList from './annotationList/AnnotationList';
import CloseSidebarButton from './CloseSidebarButton';
import AnnotationsVisibilityButton from './AnnotationsVisibilityButton';
import a11yService from '../../services/a11yService';

const AnnotationsSidebar = () => {
    const annotationsSidebarRef = useRef(null);

    useEffect(() => {
        a11yService.addFocusTrap(annotationsSidebarRef.current);

        return () => {
            a11yService.removeFocusTrap(annotationsSidebarRef.current);
            a11yService.jumpToLastFocused();
        };
    }, []);

    return (<div
        id="annotations-sidebar"
        role="complementary"
        className={styles.sideBar}
        ref={annotationsSidebarRef}
    >
        <div
            className={styles.header}
        >
            <div className={styles.titleContainer}>
                <span className={styles.title}>{t('annotations.sidebarTitle')}</span>
            </div>

            <div className={styles.buttonsContainer}>
                <AnnotationsVisibilityButton />
                <CloseSidebarButton />
            </div>
        </div>

        <div className={styles.container}>
            <AnnotationList />
        </div>
    </div>);
};

export default AnnotationsSidebar;
